<template>
  <div class="advItem">
    <Header v-if="schoolCode === '10488' && istzgg === '1'" title="公告详情" type="1" route="/new/Msg_10488"></Header>
    <Header v-else title="公告详情" type="1" route="/adv"></Header>
    <div class="advItem_header">
      <h3 class="advItem_title">{{ advItemLists.ggbt }}</h3>
      <ul class="advItem_info">
        <li>{{ advItemLists.gglbname }}</li>
        <li>{{ advItemLists.ggfsr }}</li>
        <li>{{ advItemLists.ggfbsj }}</li>
      </ul>
      <div class="advItem_time">
        <span>有效期：</span>
        <p>{{ advItemLists.ggkssj }}~{{ advItemLists.ggjssj }}</p>
      </div>
    </div>
    <div class="advItem_content" v-html="advItemLists.ggnr"></div>
    <div class="back_top" @click="backTop">
      <van-icon name="back-top" />
    </div>
    <div class="d-five">
      <div class="d-f-title">附件</div>
      <p class="d-f-p" @click="downloadFile()">{{ advItemLists.fjname }}</p>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import service from "@/utils/request";
export default {
  data() {
    return {
      advItemLists: {},
      isShow: false,
      query_id : this.$route.query.id,
      schoolCode: sessionStorage.getItem("schoolCode"),
      istzgg : this.$route.params.istzgg
    };
  },
  methods: {
    backTop() {
      $(".advItem_content")[0].scrollTop = 0;
    },
    async getList() {
      const params = {
        ggid: this.$route.params.ggid
      };
      const res = await Api.getAdvItemList(params);
      this.advItemLists = res.data[0];
      if (this.advItemLists.fjname) {
        this.isShow = !this.isShow;
      }
    },
    async downloadFile() {
      let baseURL = this.advItemLists.baseurl;
      let token = sessionStorage.getItem("Token");
      let url =
        baseURL +
        "/ggly/downfile?token=" +
        token +
        "&ggid=" +
        this.$route.params.ggid;

      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  },
  created() {
    if(this.query_id != null){
      this.$route.params.ggid = this.query_id;
    }
    this.getList();
    if (this.$route.params.isck == "0") {
      const params = {
        msgId: this.$route.params.ggid,
        msgType: "ggly"
      };
      const res = Api.getMessageMarkRead(params);
    }
  }
};
</script>
<style lang="less" scoped>
.advItem {
  height: 100%;
  box-sizing: border-box;
  .advItem_header {
    padding: 9px 15px;
    border-bottom: 1px solid #e5e5e5;
    .advItem_title {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      line-height: 31px;
      font-weight: bolder;
      margin-bottom: 6px;
    }
    .advItem_info {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      li {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: lighter;
        line-height: 17px;
        margin-right: 12px;
      }
    }
    .advItem_time {
      display: flex;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      font-weight: lighter;
      line-height: 17px;
    }
  }
  .advItem_content {
    padding: 13px 15px;
    height: calc(~"100% - 94px - 145px");
    overflow: auto;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 28px;
    font-weight: 400;
  }
  .back_top {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 8px;
    bottom: 20%;
    width: 40px;
    height: 40px;
    background: #7469f8;
    background-color: #7469f8;
    border-radius: 50%;
    .van-icon {
      color: #fff;
      font-weight: bolder;
      font-size: 25px;
    }
  }
  .d-five {
      padding: 1.25rem;
      .d-f-title {
        font-size: 1.0625rem;
        font-weight: 500;
        color: #333;
        padding-bottom: .75rem;
        margin-bottom: .75rem;
        border-bottom: 1px solid #e5e5e5;
      }
      .d-f-p {
        font-size: .875rem;
        color: #3f7adb;
        margin-bottom: 1.5625rem;
        line-height: 1.25rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AdvItem.vue